module.exports = __webpack_public_path__ + "media/images/checkmark-569e2149789afcaf4e9997d09ba80301.svg";